import { JetView } from "webix-jet"; // Importing the JetView class from Webix Jet framework
import Filter from "views/watchListReport/filterReport"; // Importing the filter component for the report view
import Table from "views/watchListReport/tableReport"; // Importing the table component for displaying data
import { devConfig } from "config/config"; // Importing configuration file that holds app constants and settings

/**
 * Class representing the WatchListReportView.
 * Integrates filter, table, and toolbar for the Watch List report module.
 */
export default class WatchListReportView extends JetView { // Defining a new class that extends Webix JetView
    config() { // Method that defines the UI configuration
        const _ = this.app.getService("locale")._; // Getting localization function for translations
        const theme = this.app.config.theme; // Accessing the current app theme configuration

        const toolbar = { // Defining the toolbar configuration
            view: "toolbar", // Webix toolbar component
            id: "toolbar", // Setting unique ID for the toolbar
            css: "highlighted_header header6", // Applying CSS classes for visual style
            height: 40, // Setting toolbar height
            paddingX: 5, // Horizontal padding
            paddingY: 5, // Vertical padding
            cols: [ // Toolbar contains multiple elements arranged in columns
                {
                    view: "select", // Dropdown select component for page size
                    options: ["10", "20", "50", "100"], // Options for pagination sizes
                    width: 70, // Setting width of the select
                    on: { // Defining event handlers
                        onChange: function () { // Triggered when the select value changes
                            const pager = $$("pagerA").config; // Accessing pager configuration
                            pager.size = this.getValue() * 1; // Setting new page size (cast to number)
                            $$("datatable").refresh(); // Refreshing first datatable
                            $$("datatable2").refresh(); // Refreshing second datatable
                        },
                    },
                },
                {
                    view: "pager", // Webix pager component
                    id: "pagerA", // Unique ID for the pager
                    template: "{common.first()}{common.prev()} {common.pages()} {common.next()}{common.last()}", // Pager template buttons
                    size: devConfig.getDefaultDataFetch(), // Default page size from configuration
                    height: 35, // Pager height
                },
                {
                    view: "richselect", // Dropdown select for export options
                    id: "Export", // Unique ID
                    width: 120, // Width of the select
                    placeholder: _("Exportar"), // Placeholder text (localized)
                    options: [ // Dropdown options for file export
                        { id: "1", value: "Excel" }, // Option for Excel export
                        { id: "2", value: "PDF" }, // Option for PDF export
                    ],
                    on: { // Event handlers for the export select
                        onChange: function (value) { // Triggered when user selects an export type
                            const table = $$("datatable").isVisible() ? $$("datatable") : $$("datatable2"); // Determine which table is visible
                            const pager = $$("pagerA").config; // Get pager configuration
                            const size = pager.size; // Get current page size
                            const page = table.getPage(); // Get current page number
                            const first = size * page; // Calculate first record index on current page
                            const last = first + size - 1; // Calculate last record index on current page

                            const baseName = "Virtualsoft - Reporte de listas de observados - " +
                                new Date().toLocaleString("es-CO").replace(/[\/:]/g, "_"); // Generate export filename with timestamp

                            if (value == "1") { // If user selected Excel
                                webix.toExcel(table, { // Export visible rows to Excel
                                    filter: (obj) => { // Define export filter
                                        const idx = table.getIndexById(obj.id); // Get row index
                                        return idx >= first && idx <= last; // Include only visible rows
                                    },
                                    filename: baseName, // Set export file name
                                    ignore: { ActionTittle: true }, // Ignore this column when exporting
                                });
                            } else if (value == "2") { // If user selected PDF
                                webix.toPDF(table, { // Export visible rows to PDF
                                    filter: (obj) => { // Define export filter
                                        const idx = table.getIndexById(obj.id); // Get row index
                                        return idx >= first && idx <= last; // Include only visible rows
                                    },
                                    filename: baseName, // Set export file name
                                    autowidth: true, // Automatically adjust column width
                                    ignore: { ActionTittle: true }, // Ignore this column when exporting
                                });
                            }
                            this.setValue(""); // Reset dropdown after export
                        },
                    },
                },
            ],
        };

        return { // Return the full view layout configuration
            id: "watchListReportMain", // Unique ID for the main view
            type: "clean", // Clean layout type (without borders)
            rows: [ // Main view divided into rows
                {
                    view: "toolbar", // Header toolbar
                    css: theme, // Apply current theme CSS
                    elements: [ // Elements inside header toolbar
                        { gravity: 1 }, // Spacer to center the label
                        {
                            view: "label", // Label component
                            label: _("Reporte de listas de observados"), // Localized title text
                            align: "center", // Center text alignment
                            css: { "text-align": "center", "font-weight": "600" }, // Custom styles
                        },
                        { gravity: 1 }, // Another spacer
                        {
                            view: "icon", // Icon button
                            icon: "wxi-close", // Close icon
                            width: 30, // Button width
                            click: () => this.show("/top/dashboard"), // Navigate back to dashboard on click
                        },
                    ],
                },
                Filter, // Include the filter component below the header
                Table, // Include the table component
                toolbar, // Include the bottom toolbar (pagination + export)
            ],
        };
    }

    init() { // Method called after view initialization
        webix.ready(() => { // Execute when Webix environment is ready
            if (screen.width < 500 || screen.height < 500) { // Check if the screen is small (mobile device)
                const childs = $$("toolbar").getChildViews(); // Get all child components from toolbar
                $$("toolbar").removeView(childs[2]); // Remove the export dropdown to save space
                $$("pagerA").define("group", 1); // Simplify pager view for small screens
            }
        });
    }
}
